import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GorgiasIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GorgiasIntegrationResponseDataSchema>>

export const gorgiasIntegrationQueryKey = ["gorgiasIntegration"]

type Props = {
  onSuccess?: (data: Response) => void
}

export const gorgiasIntegrationQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: gorgiasIntegrationQueryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/gorgias`)

      onSuccess?.(response.data)

      return response.data.data ?? null
    },
  })
}
